export default {"src":"/_next/static/media/google-hangouts.66f5e35a.svg","height":2500,"width":2144};